export default function Loading() {
    return <div class="loader"></div>
}